import ServiceBase from "base/baseService"
import queryString from "query-string"

export default class TipoOperacaoFiscalService extends ServiceBase {

    title = "Tipo de operação"
    pluralTitle = "Tipos de operações"
    url = '/cadastro/fiscal/tipooperacao_fiscal'
    frontUrl = '/cadastro/fiscal/tipooperacao_fiscal'
    frontUrlList = '/cadastro/fiscal/tipooperacao_fiscallist'
    primaryKey = 'codigo_tiof'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        // Strings notNullable

        data.descricao_tiof = data?.descricao_tiof || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

    async listTipoOperacao({ codsTipoOperacao = [] }) {

        if (!codsTipoOperacao) return

        const search = { page: 1, perPage: 99 }

        search.cods_tiof = codsTipoOperacao

        return await this.list('?' + queryString.stringify(search))

    }

}
